import type { Resource } from '../../';
export const forms_field_sendShippingNotification: Resource = {"default":"Send shipping notification updates via text message."};
